/**
 * `requiredLevelAvailable` (人材像が求める水準列の表示可否) 導出ロジック (純粋関数)。
 * docs/design/v05-skill-registration-table-redesign-detail.md §4-8。
 *
 * D-636 により self scope しか持たないユーザーが GET /competency/matrix を呼ぶと常に403になる。
 * 主所属 node_id が未解決の場合も同様に呼び出し自体を行わない。既存の確立パターン
 * (MyFamilyPage.tsx:657-659) に合わせ、featureDisabled (competency_management フラグ OFF) と
 * scopeForbidden (D-636 による self scope 403) を区別して保持しつつ、UI 上の振る舞いは
 * どちらも列非表示に倒す。
 */
import { ApiClientError } from './api';

export type SkillMatrixFallbackInput = {
  /** §4-4-1 で解決した主所属 node_id。null なら matrix 自体を呼んでいない状態。 */
  nodeId: string | null;
  /** GET /competency/matrix の useQuery が返すエラー有無・エラー本体。 */
  isError: boolean;
  error: unknown;
};

export type SkillMatrixFallbackResult = {
  /** true なら「人材像が求める水準」列を表示してよい。 */
  requiredLevelAvailable: boolean;
  /** competency_management フラグ自体が OFF (FEATURE_DISABLED)。 */
  featureDisabled: boolean;
  /** D-636 による self scope 403 (フラグは有効、権限で弾かれた)。 */
  scopeForbidden: boolean;
};

export function deriveRequiredLevelAvailable(input: SkillMatrixFallbackInput): SkillMatrixFallbackResult {
  const { nodeId, isError, error } = input;
  const featureDisabled = error instanceof ApiClientError && error.code === 'FEATURE_DISABLED';
  const scopeForbidden = error instanceof ApiClientError && error.status === 403 && !featureDisabled;
  const requiredLevelAvailable = !!nodeId && !featureDisabled && !scopeForbidden && !isError;
  return { requiredLevelAvailable, featureDisabled, scopeForbidden };
}
